<template>
  <div class="terms-container">
    <div class="terms-content">
      <h2><b>Platform Rules</b></h2>
      <p>1. Each user can only have one account; multiple accounts from the same IP address or one person are prohibited.</p>
      <p>2. To ensure the security of your users' funds, you need to bind your withdrawal wallet address.</p>
      <p>3. For short dramas promoted for 20 days, the traffic period may end in 17-25 days. This is because your promotional data will generate residual organic traffic.</p>
      <p>4. The platform's traffic is pushed to various countries worldwide, and most payments for short dramas are made in local currencies. To facilitate settlement, the platform needs time to convert to USDT, so the repayment cycle is 6 days.</p>
      <p>5. Distribution of promotional funds: 1-5 days: 5% - Cold start period; 6-10 days: 20% (content verification period); 11-15 days: 40% (IP building period); 16-20 days: 35% (short drama matrix period).</p>
      <p>6. Our platform places great emphasis on copyright. You need to pay the copyright holder within 24 hours; otherwise, your work will be considered an infringement during various advertising phases.</p>
      <p>7. When your short drama becomes popular, you will become a shareholder of the copyright holder after the advertising period ends, enjoying 30% of the copyright holder's profits.</p>
      <p>8. To ensure a fair and transparent market, each user is limited to advertising a maximum of 5 dramas every 3 months.</p>
      <p>9. Your account balance can be withdrawn at any time, with funds arriving within 24 hours.</p>
      <p>10. Our platform's settlement time is: Washington D.C. time.</p>
      <p>11. After you pay the advertising fee, our platform will have professional advertisers who will publish the short drama on various short video platforms. Initially, we have only 15 accounts. As advertising traffic increases, we will add 100-2000 accounts as needed. If advertising traffic decreases, we will not reduce the number of accounts.</p>
      <p><b>• Comply with the advertising platform's rules.<br />• Comply with local laws and regulations.<br />• Do not use the platform for illegal activities.<br />• Cooperate with the platform's risk control review.</b></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RuleView',
}
</script>

<style scoped>
.terms-container {
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
  line-height: 1.7;
}

.terms-content {
  max-width: 1200px;
  width: 100%;
  background: white;
  padding: 60px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  color: #333;
}

h2 {
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin: 40px 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e9ecef;
}

h2:first-child {
  margin-top: 0;
}

h4 {
  color: #34495e;
  font-size: 20px;
  font-weight: 500;
  margin: 30px 0 15px 0;
}

p {
  margin-bottom: 16px;
  font-size: 16px;
  color: #555;
}

.highlight {
  color: #3498db;
  font-weight: 500;
  background: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
}

.warning {
  background: #f8d7da;
  padding: 16px 20px;
  border-left: 4px solid #dc3545;
  border-radius: 4px;
  font-weight: 500;
  color: #721c24;
}

.link {
  color: #3498db;
  text-decoration: underline;
  cursor: pointer;
}

.link:hover {
  color: #2980b9;
}

/* 列表样式 */
.terms-content p:has(> b) {
  margin: 20px 0 10px 0;
  font-weight: 600;
  color: #2c3e50;
}

.terms-content p:has(> span.highlight) {
  margin: 15px 0;
}

/* 字母列表样式 */
/* .terms-content p:has(>(a)) {
  margin-left: 20px;
  position: relative;
}

.terms-content p:has(>(a))::before {
  content: '(' attr(data-letter) ')';
  position: absolute;
  left: -20px;
  font-weight: 600;
} */

/* 响应式设计 */
@media (max-width: 768px) {
  .terms-content {
    padding: 30px 20px;
    margin: 0 10px;
  }

  h2 {
    font-size: 24px;
  }

  h4 {
    font-size: 18px;
  }

  p {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .terms-container {
    padding: 20px 10px;
  }

  .terms-content {
    padding: 20px 15px;
  }

  h2 {
    font-size: 22px;
  }

  h4 {
    font-size: 17px;
  }
}
</style>
